import { render, staticRenderFns } from "./SubFormFmhMig.vue?vue&type=template&id=b35cb13a&"
import script from "./SubFormFmhMig.vue?vue&type=script&lang=js&"
export * from "./SubFormFmhMig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports